
import React from 'react';
import { AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Printer } from 'lucide-react';

export const AlertContent: React.FC = () => {
  return (
    <>
      <AlertTitle className="text-blue-700 font-bold text-sm md:text-base">Lưu ý quan trọng</AlertTitle>
      <AlertDescription className="text-blue-700 text-xs md:text-sm">
        <p className="mt-0.5">
          Sau khi đăng ký, <span className="font-bold">lưu lại mã QR</span> và thông tin đăng ký bằng cách bấm nút 
          <span className="inline-flex items-center mx-1 px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded text-xs font-medium">
            <Printer className="h-3 w-3 mr-1" /> In thông tin đăng ký
          </span>. 
          Email xác nhận có thể vào thư mục spam.
        </p>
      </AlertDescription>
    </>
  );
};
